import React from 'react'
import { createStyles, Theme, withStyles } from '@material-ui/core/styles'
import useStyles from './Styles'
import { ILinkPanelProps } from '../Interfaces'
import { Grid, Paper, Typography, InputBase, Button } from '@material-ui/core'

const BootstrapInput = withStyles((theme: Theme) =>
  createStyles({
    root: {
      'label + &': {
        marginTop: theme.spacing(3)
      }
    },
    input: {
      position: 'relative',
      backgroundColor: '#FFF',
      borderBottom: '1px solid #AC9BC7',
      fontSize: 16,
      width: '70%',
      padding: '10px 0px'
    }
  })
)(InputBase)

const LinkPanel: React.FC<ILinkPanelProps> = ({
  error,
  linkUrl,
  linkName,
  saveLink,
  isSavingLink,
  onChangeLinkName,
  onChangeLinkUrl
}) => {
  const classes = useStyles()
  return (
    <Grid item className={[classes.mediaContainer].join(' ')} justify="flex-end" alignItems="baseline">
      <Paper className={classes.paper}>
        <Typography variant="subtitle1" id="media-upload-file-label-input-label">
          Add a link
        </Typography>
        <Typography className={classes.uploadPdfLabel} variant="body2" id="media-upload-file-detail-label-input-label">
          Add a link to media that you would like to be featured
        </Typography>
        <Typography className={classes.errorUrl} id="media-upload-file-error-label">
          {error ? 'Invalid url.' : ''}
        </Typography>
        <Grid
          container
          justify="flex-end"
          alignItems="baseline"
          className={classes.selectedFileContainer}
          style={{ height: 247 }}
        >
          <Grid container direction="column">
            <BootstrapInput
              placeholder="Link title"
              id="bootstrap-input"
              value={linkName}
              onChange={(e: any) => onChangeLinkName(e.target.value)}
            />
            <BootstrapInput
              style={{ marginTop: 20 }}
              placeholder="https://"
              id="bootstrap-input"
              value={linkUrl}
              onChange={(e: any) => onChangeLinkUrl(e.target.value)}
            />
          </Grid>
          <Button
            id="media-upload-file-selected-upload-button"
            variant="contained"
            type="submit"
            onClick={saveLink}
            disabled={isSavingLink || !linkUrl || !linkName}
          >
            Save
          </Button>
        </Grid>
      </Paper>
    </Grid>
  )
}

export default LinkPanel
